import type { Dict } from "../core.js";
import type { resale as vi } from "../vi/resale.js";

/** Namespace `resale` — PLAT-2026-174 · ADR-054, English. */
export const resale: Dict<typeof vi> = {
  title: "Partner service resale",
  subtitle: "The hub owns the whole lifecycle: opening services to apps, plans + prices + discounts, new-purchase / renewal requests and the expiry report. Apps only display and send requests here.",
  tabConfig: "On sale and prices",
  tabRequests: "Requests",
  tabExpiry: "Expiring",
  loadFailed: "Could not load resale data.",
  saveFailed: "Could not save.",
  saved: "Saved.",
  dirOutbound: "Outbound (sales)",
  dirInbound: "Inbound (purchases)",
  fulfilmentManual: "Staff handle manually",
  fulfilmentAgency: "Agency channel (API)",
  offeringsTitle: "Services opened to apps",
  offeringsHint: "Turn on “On sale” and customers in the app see this service (with the plans and prices below). It only shows while Bube's reselling contract with that provider is in effect.",
  fieldService: "Service",
  fieldDirection: "Direction",
  fieldListed: "On sale",
  fieldFulfilment: "Handling",
  fieldDiscountNew: "New-purchase discount (%)",
  fieldDiscountRenew: "Renewal discount (%)",
  fieldPriceSource: "Use price list of",
  priceSourceSelf: "This service itself",
  fieldNote: "Note",
  save: "Save",
  edit: "Edit",
  noOfferings: "No service is opened to this app yet.",
  listedYes: "On sale",
  listedNo: "Off",
  plansTitle: "Plans and public prices",
  plansHint: "Changing a price = adding a new level with a new effective date. A level already in effect cannot be edited (requests snapshot the price); to stop selling, add a new level and untick “Selling”.",
  fieldPlanCode: "Plan code",
  fieldPlanName: "Plan name",
  fieldQuota: "Invoices",
  fieldTerm: "Term (months)",
  fieldPrice: "Public price (₫)",
  fieldEffective: "Effective from (YYYY-MM-DD)",
  fieldActive: "Selling",
  addPlan: "Add price level",
  noPlans: "No plans yet.",
  unlimited: "Unlimited",
  requestsTitle: "Purchase / renewal request queue (all apps)",
  filterAll: "All statuses",
  empty: "No requests.",
  colWhen: "Sent",
  colApp: "App",
  colCompany: "Company",
  colContact: "Contact",
  colPlan: "Plan",
  colPrice: "Price",
  colStatus: "Status",
  kind_new: "New purchase",
  kind_renew: "Renewal",
  priceLine: "{net} (public {pub}, {pct}% off)",
  status_submitted: "Submitted",
  status_in_review: "In review",
  status_approved: "Approved",
  status_fulfilled: "Fulfilled",
  status_rejected: "Rejected",
  status_cancelled: "Cancelled",
  action_in_review: "Take it",
  action_approved: "Approve",
  action_fulfilled: "Complete",
  action_retry: "Re-run Agency Core",
  action_rejected: "Reject",
  action_cancelled: "Cancel",
  confirmTaxCode: "Retype tax code {taxCode} to confirm the real operation at the provider",
  decidedBy: "Handled by {who}",
  expiryTitle: "Expiry report",
  expiryWithin: "Show subscriptions expiring within (days)",
  expiryEmpty: "No subscription is expiring or expired.",
  colService: "Service",
  colTax: "Tax code",
  colExpires: "Expires",
  colDaysLeft: "Days left",
  state_active: "Active",
  state_expiring: "Expiring soon",
  state_expired: "Expired",
  taxMatch: "Tax code matches the company profile",
  taxMismatch: "⚠ Tax code DIFFERS from the customer's company profile ({code})",
  taxNoProfile: "⚠ Customer has no company profile — tax code cannot be cross-checked",
  decisionNoteHint: "Handling note (the customer SEES it on reject / cancel)",
  subsTitle: "Record an existing subscription",
  subsHint: "For customers who bought outside the system. The same (workspace, tax code, service, direction) updates the existing subscription's term. Get the workspace ID from the app's customers page.",
  subsWorkspace: "Workspace ID",
  subsTax: "Tax code",
  subsStarts: "Starts (YYYY-MM-DD)",
  subsExpires: "Expires (YYYY-MM-DD)",
  subsSave: "Record subscription",
  subsApp: "App",
};
